// "http://" or "https://", repeated or not, at the start of a website. The
// prefixed input (components/form/RHFInput) strips it with this same pattern.
export const WEBSITE_SCHEME = /^(https?:\/\/)+/i;

/**
 * A website as it should be sent: the trimmed address when something follows
 * the scheme, otherwise "". The field shows a locked "https://", and an older
 * record can hold a bare "https://" or spaces, neither of which is a link.
 *
 * @param {string|null|undefined} value
 * @returns {string}
 */
export const websiteValue = (value) => {
  const trimmed = String(value ?? "").trim();
  return trimmed.replace(WEBSITE_SCHEME, "").trim() ? trimmed : "";
};
